module.exports = __webpack_public_path__ + "img/second.385b138c.svg";